import { StandardTextFieldProps, TextField } from '@mui/material';
import React from 'react';
import { Field } from '../../../types/generic';
import { getHelperText } from '../../../utils/form';

interface FormTextFieldProps {
	fieldData: Field;
	textFieldProps: StandardTextFieldProps;
}

const FormTextField: React.FC<FormTextFieldProps> = ({ fieldData, textFieldProps }) => {
	return (
		<TextField
			variant="outlined"
			value={fieldData.value}
			helperText={getHelperText(fieldData)}
			error={fieldData.error}
			required={fieldData.required}
			{...textFieldProps}
			data-testid={`${textFieldProps.name}-textfield`}
		/>
	);
};

export default FormTextField;
